export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const SPINNER_MODAL = 'SPINNER_MODAL'
